import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

import { GlobalCfgService } from './globalcfg.service';

/**
 *	Provider to do the parts related funtionality.
 */
@Injectable()
export class MedicineService {
  constructor(
    private http: HttpClient,
    private globalCfgService: GlobalCfgService
  ) {}

  public get(rec, sortBy?: String, sortOrder?: String) {
    const body = {
      ...rec,
      ...(sortBy && { sortBy }),
      ...(sortOrder && { sortOrder }),
    };
    return this.http.post(
      environment.apiurl +
        '/Medicines/all/?access_token=' +
        this.globalCfgService.getAccessToken(),
      body
    );
  }


  public details(obj) {
    return this.http.post(
      environment.apiurl +
        '/Medicines/details?access_token=' +
        this.globalCfgService.getAccessToken(),
      obj
    );
  }

  public getList(gcp) {
    var filter = '';
    if (gcp) {
      filter = '&gcp=' + gcp;
    }

    return this.http.get(
      environment.apiurl +
        '/Medicines/list?access_token=' +
        this.globalCfgService.getAccessToken() +
        filter
    );
  }

  public getListByLocation(rec) {
    return this.http.post(
      environment.apiurl +
        '/Medicines/listByGln/?access_token=' +
        this.globalCfgService.getAccessToken(),
      rec
    );
  }

  public add(rec) {
    return this.http.post(
      environment.apiurl +
        '/Medicines/add?access_token=' +
        this.globalCfgService.getAccessToken(),
      rec
    );
  }

  public update(rec) {
    return this.http.post(
      environment.apiurl +
        '/Medicines/update?access_token=' +
        this.globalCfgService.getAccessToken(),
      rec
    );
  }

  public getProductData(gtin) {
    return this.http.get(
      environment.apiurl +
        '/Medicines/' +
        gtin +
        '?access_token=' +
        this.globalCfgService.getAccessToken()
    );
  }
}
